export default __webpack_public_path__ + "static/media/trampapo_02_32.1ec59088.jpg";